var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPathHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M101.949 23.5234L94.223 110.07L59.4962 119.697L24.865 110.083L17.1475 23.5234H101.949Z",
    fill: "#E44D26"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5488 112.338L87.6098 104.559L94.2115 30.6011H59.5488V112.338Z",
    fill: "#F16529"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5298 51.833H59.5481V41.2168H32.9277L33.1817 44.0649L35.7911 73.3203H59.5481V62.7041H45.5001L44.5298 51.833ZM46.9225 78.6285H36.2655L37.7527 95.2976L59.4993 101.334L59.5481 101.321V90.2755L59.5016 90.2878L47.6784 87.0954L46.9225 78.6285Z",
    fill: "#EBEBEB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0381 0H30.4331V5.33019H35.3684V0H40.7637V16.1412H35.3687V10.7362H30.4334V16.1412H25.0384V0H25.0381ZM47.858 5.3528H43.1092V0H58.0058V5.3528H53.254V16.1412H47.859V5.3528H47.8587H47.858ZM60.3699 0H65.9953L69.4557 5.67158L72.9128 0H78.5405V16.1412H73.1674V8.14072L69.4557 13.8798H69.3626L65.6486 8.14072V16.1412H60.3699V0ZM81.2253 0H86.622V10.806H94.2089V16.1412H81.225V0H81.2253Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5121 73.3203H72.5847L71.3522 87.0887L59.5117 90.2845V101.329L81.2756 95.2976L81.4351 93.5039L83.9302 65.5549L84.1892 62.7041H59.5121V73.3203ZM59.5121 51.807V51.833H85.1551L85.3679 49.4469L85.8519 44.0649L86.1055 41.2168H59.5121V51.8074V51.807Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPathHtml);
export default __webpack_public_path__ + "static/media/path-html.4ecbc1065f4a900b4f2692567e308d0e.svg";
export { ForwardRef as ReactComponent };